import { useCallback, useRef } from 'react';
import { useWebRTC } from '../context/WebRTCContext';

/**
 * Hook that provides a stable function to emit command events onto the Sacred Timeline.
 * Used to record Inquisitor actions (viewing keylogs, browsing files, taking screenshots, etc.)
 * so the AI and timeline have a complete picture of both sides.
 *
 * Usage:
 *   const emitTimelineEvent = useTimelineEmit();
 *   emitTimelineEvent('inquisitor.viewed_keylogs', {
 *     title: 'Viewed keystroke logs',
 *     data: { timeRange, entryCount: logs.length }
 *   });
 */
export function useTimelineEmit() {
    const { sendFeatureMessage } = useWebRTC();
    const sendRef = useRef(sendFeatureMessage);
    sendRef.current = sendFeatureMessage;

    const emitTimelineEvent = useCallback((type, eventData = {}) => {
        if (!sendRef.current) return;

        sendRef.current({
            feature: 'sacred-timeline',
            cmd: 'timeline_emit',
            payload: {
                type,
                source: 'inquisitor',
                ...eventData
            }
        });
    }, []);

    return emitTimelineEvent;
}
